exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".data-source-tree[data-v-044a61a2]::-webkit-scrollbar{width:6px}", ""]);

// exports
